import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0595 = React.lazy(() => import('./symbols/0595_music_note_playing_sound_song'));
const Symbol0596 = React.lazy(() => import('./symbols/0596_music_note_playing_sound_song'));
const Symbol0597 = React.lazy(
  () => import('./symbols/0597_playlist_music_note_playing_sound_song')
);
const Symbol0598 = React.lazy(() => import('./symbols/0598_music_ipod_playing_player_playlist'));
const Symbol0599 = React.lazy(() => import('./symbols/0599_ipod_music_playing_song'));
const Symbol0600 = React.lazy(() => import('./symbols/0600_music_playing_song_album'));
const Symbol0601 = React.lazy(() => import('./symbols/0601_music_cloud_song_streaming'));
const Symbol0602 = React.lazy(() => import('./symbols/0602_casette_music_song_radio'));
const Symbol0603 = React.lazy(() => import('./symbols/0603_dj_music_disc_disco'));
const Symbol0604 = React.lazy(() => import('./symbols/0604_radio_song_listening'));
const Symbol0605 = React.lazy(() => import('./symbols/0605_ringer_alarm_sound'));
const Symbol0606 = React.lazy(() => import('./symbols/0606_ringer_alarm_sound_silent_mute'));
const Symbol0607 = React.lazy(() => import('./symbols/0607_ringer_sound_speaker_laud'));
const Symbol0608 = React.lazy(() => import('./symbols/0608_ringer_sound_speaker_laud'));
const Symbol0609 = React.lazy(() => import('./symbols/0609_ringer_sound_speaker_laud'));
const Symbol0610 = React.lazy(() => import('./symbols/0610_ringer_sound_speaker_mute_silent'));
const Symbol0611 = React.lazy(() => import('./symbols/0611_microphone_mic_voice_recording'));
const Symbol0612 = React.lazy(() => import('./symbols/0612_microphone_mic_voice_recording'));
const Symbol0613 = React.lazy(() => import('./symbols/0613_voice_laud_announcement_news'));
const Symbol0614 = React.lazy(() => import('./symbols/0614_speaker_music_sound_playing'));
const Symbol0615 = React.lazy(() => import('./symbols/0615_ringer_silent_sleeping'));
const Symbol0616 = React.lazy(() => import('./symbols/0616_headphones_headset_speaker_beats'));

export interface IProps {}

const Sound: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0595_music_note_playing_sound_song" symbol={<Symbol0595 />} />
      <LazySymbol id="0596_music_note_playing_sound_song" symbol={<Symbol0596 />} />
      <LazySymbol id="0597_playlist_music_note_playing_sound_song" symbol={<Symbol0597 />} />
      <LazySymbol id="0598_music_ipod_playing_player_playlist" symbol={<Symbol0598 />} />
      <LazySymbol id="0599_ipod_music_playing_song" symbol={<Symbol0599 />} />
      <LazySymbol id="0600_music_playing_song_album" symbol={<Symbol0600 />} />
      <LazySymbol id="0601_music_cloud_song_streaming" symbol={<Symbol0601 />} />
      <LazySymbol id="0602_casette_music_song_radio" symbol={<Symbol0602 />} />
      <LazySymbol id="0603_dj_music_disc_disco" symbol={<Symbol0603 />} />
      <LazySymbol id="0604_radio_song_listening" symbol={<Symbol0604 />} />
      <LazySymbol id="0605_ringer_alarm_sound" symbol={<Symbol0605 />} />
      <LazySymbol id="0606_ringer_alarm_sound_silent_mute" symbol={<Symbol0606 />} />
      <LazySymbol id="0607_ringer_sound_speaker_laud" symbol={<Symbol0607 />} />
      <LazySymbol id="0608_ringer_sound_speaker_laud" symbol={<Symbol0608 />} />
      <LazySymbol id="0609_ringer_sound_speaker_laud" symbol={<Symbol0609 />} />
      <LazySymbol id="0610_ringer_sound_speaker_mute_silent" symbol={<Symbol0610 />} />
      <LazySymbol id="0611_microphone_mic_voice_recording" symbol={<Symbol0611 />} />
      <LazySymbol id="0612_microphone_mic_voice_recording" symbol={<Symbol0612 />} />
      <LazySymbol id="0613_voice_laud_announcement_news" symbol={<Symbol0613 />} />
      <LazySymbol id="0614_speaker_music_sound_playing" symbol={<Symbol0614 />} />
      <LazySymbol id="0615_ringer_silent_sleeping" symbol={<Symbol0615 />} />
      <LazySymbol id="0616_headphones_headset_speaker_beats" symbol={<Symbol0616 />} />
    </>
  );
});

export default Sound;
